import React from "react";
import { useRecoilState } from "recoil";
import { Icon, Menu } from "semantic-ui-react";

import { showTimeline, viewingDescription } from "./atoms";

import { commands$ } from "./CommandsStream";

export function TimelineButton() {
  const [active, setActive] = useRecoilState(showTimeline);
  const [descViewActive, setDescViewActive] = useRecoilState(viewingDescription);

  const toggle = () => {
    const goingToBeActive = !active;
    
    setActive(goingToBeActive);

    if (goingToBeActive && !descViewActive) {
      setDescViewActive(true);
      commands$.showDescription();
    }
  };

  return (
    <Menu.Item onClick={toggle} active={active}>
      <Icon name="history" />
      <br />
      Timeline
    </Menu.Item>
  );
}
